


























































































































import { Inject, Prop, Component, Vue } from 'vue-property-decorator'
import { WinckCollection, WinckFilter } from '@/api/client/winck-proxy'
import BedroomsField from '@/views/Company/Settings/Narrowcasting/Collections/FilterField/BedroomsField.vue'
import ConstructionYearField from '@/views/Company/Settings/Narrowcasting/Collections/FilterField/ConstructionYearField.vue'
import OpenHouseDayField from '@/views/Company/Settings/Narrowcasting/Collections/FilterField/OpenHouseDayField.vue'
import PriceField from '@/views/Company/Settings/Narrowcasting/Collections/FilterField/PriceField.vue'
import PublicationDateField from '@/views/Company/Settings/Narrowcasting/Collections/FilterField/PublicationDateField.vue'
import RoomsField from '@/views/Company/Settings/Narrowcasting/Collections/FilterField/RoomsField.vue'
import SurfaceField from '@/views/Company/Settings/Narrowcasting/Collections/FilterField/SurfaceField.vue'
import CityField from '@/views/Company/Settings/Narrowcasting/Collections/FilterField/CityField.vue'
import StreetField from '@/views/Company/Settings/Narrowcasting/Collections/FilterField/StreetField.vue'
import ConstructionTypeField from '@/views/Company/Settings/Narrowcasting/Collections/FilterField/ConstructionTypeField.vue'
import EnergyRatingField from '@/views/Company/Settings/Narrowcasting/Collections/FilterField/EnergyRatingField.vue'
import StatusField from '@/views/Company/Settings/Narrowcasting/Collections/FilterField/StatusField.vue'
import { namespace } from 'vuex-class'
import { cloneDeep } from 'lodash'
const narrowcasting = namespace('narrowcasting')

@Component({
    components: {
        StatusField,
        EnergyRatingField,
        ConstructionTypeField,
        StreetField,
        CityField,
        SurfaceField,
        RoomsField,
        PublicationDateField,
        PriceField,
        OpenHouseDayField,
        ConstructionYearField,
        BedroomsField,
    },
})
export default class CompanySettingsNarrowcastingCollectionsEdit extends Vue {
    @Prop({ required: true }) readonly collectionId!: string
    @Inject() readonly navigateToList: () => Promise<void>
    @narrowcasting.State readonly error!: string
    @narrowcasting.State readonly saving!: boolean
    @narrowcasting.State readonly collections!: WinckCollection[]
    @narrowcasting.Action readonly updateCollection: (collection: WinckCollection) => Promise<void>
    collection: WinckCollection = null

    mounted() {
        const collection = this.collections.find(v => v.id === this.collectionId)
        if (collection) {
            this.collection = cloneDeep<WinckCollection>(collection)
        }
    }

    async onSave(): Promise<void> {
        await this.updateCollection(this.collection)
        await this.navigateToList()
    }

    async onCancel(): Promise<void> {
        await this.navigateToList()
    }

    getInitialFilterValue(name: string): any {
        const filter = this.collection.filters.find(entry => entry.field === name)
        return filter ? filter.fieldValues : []
    }

    enableFilter(filter: WinckFilter): void {
        const existing = this.collection.filters.find(entry => entry.field === filter.field)
        if (existing) {
            existing.fieldValues = filter.fieldValues
            return
        }

        this.collection.filters.push(filter)
    }

    disableFilter(filter: WinckFilter): void {
        const index = this.collection.filters.findIndex(entry => entry.field === filter.field)
        if (index >= 0) {
            this.collection.filters.splice(index, 1)
        }
    }
}
